<script setup lang="ts">
const config = useRuntimeConfig();
const brand = config.public.brand;
</script>

<template>
  <section class="footer section">
    <div class="column title">
      <nuxt-link
        :to="brand.mainPage"
        class="title-link"
      >
        <h1>{{ brand.name }}</h1>
      </nuxt-link>
      <div>
        {{ brand.tagline }}
      </div>
    </div>
    <div class="column links">
      <a
        :href="brand.statusPage"
        target="_blank"
      >
        Статус сервисов
      </a>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.footer {
  display: grid;
  grid-template-columns: 3fr 1fr;
  background: white;

  .homeLink {
    text-decoration: none;
    display: block;
    width: fit-content;

    h1 {
      width: fit-content;
    }
  }

  .column {
    text-align: left;
  }

  .links {
    display: flex;
    flex-direction: column;
    gap: 12px;

    a {
      display: block;
      line-height: 28px;
      width: fit-content;
    }
  }

  .title {
    h1 {
      font: var(--disp-32);
      margin-bottom: 16px;
    }
  }
}

.title-link {
  display: block;
  width: fit-content;
  text-decoration: none;
}

.status-circle {
  background-color: var(--clr-accent);
  height: 16px;
  width: 16px;
  border-radius: 32px;
  display: inline-block;
  margin-right: 8px;
  transform: translate(0, 2px);
}

@media screen and (max-width: 1000px) {
  .footer {
    grid-template-columns: 2fr 1fr;
  }
}

@media screen and (max-width: 880px) {
  .footer {
    display: flex;
    flex-direction: column;

    .title {
      margin-bottom: 16px;
    }
  }
}
</style>
